import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-block: 0 var(--spacing-3);
    padding-inline: var(--spacing-2);

    @media screen and (min-width: ${breakpoints.md}) {
        padding-inline: var(--spacing-8);
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    width: 100%;

    &:not(:empty) {
        margin-top: var(--spacing-3);
    }
`;

export const AdditionalActions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);
    padding-block: var(--spacing-3);
    padding-inline: var(--spacing-2);
    border-top: 1px solid var(--color-grey-4);

    @media screen and (min-width: ${breakpoints.md}) {
        padding-inline: var(--spacing-8);
    }
`;

export const TertiaryActions = styled.div`
    display: flex;
    justify-content: center;
    padding-block-start: calc(var(--spacing-1) / 2);
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`;

export const VehicleAggregation = styled.div`
    display: flex;
    align-items: center;
    align-self: stretch;
    justify-content: center;
    gap: 1rem;
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-black);

    span {
        font-family: var(--font-semi-bold);
    }
`;
